import { ColumnDef, SortingState, Updater } from "@tanstack/react-table"
import { isMobileAtom } from "atoms/app.atom"
import { GenericResource } from "models/generic"
import React from "react"
import { useAtom } from "jotai"
import { VirtualInfiniteTableDesktop } from "./VirtualInfiniteTableDesktop"
import { VirtualInfiniteTableMobile } from "./VirtualInfiniteTableMobile"
import { isAldeia } from "hooks/useAldeia"

export interface VirtualInfiniteTableProps<T extends GenericResource> {
  columns: ColumnDef<T>[]
  data: T[]
  fetchNextPage: () => void
  isFetching: boolean
  isFetchingNextPage?: boolean
  isLoading: boolean
  totalCount: number
  windowMode?: boolean
  transparentHeader?: boolean
  onClickRow?: (row: T) => void
  className?: string
  local?: boolean
  isFiltering?: boolean
  onSaveNewPositions?: (newPositions: T[]) => void
  children?: React.ReactNode
  overscan?: number
  rowHeight?: number

  // If paginated
  sorting?: SortingState
  onSortChange?: (sortState: Updater<SortingState>) => void
  layout?: "static" | "default" | "grid"
}

function VirtualInfiniteTable<T extends GenericResource>(props: VirtualInfiniteTableProps<T>) {
  const [isMobile, setIsMobile] = useAtom(isMobileAtom)

  return isMobile || !props.local || isAldeia ? <VirtualInfiniteTableMobile {...props} /> : <VirtualInfiniteTableDesktop {...props} />
}

export default VirtualInfiniteTable
